var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M111.713,44.522C152.798,16.436,202.476,0,256,0s103.202,16.436,144.287,44.522L256,55.652 L111.713,44.522z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "256,256 239.662,239.662 235.324,247.433 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M74.98,74.98c-99.974,99.974-99.974,262.065,0,362.04C116.293,395.707,156.026,355.974,256,256 L74.98,74.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M437.02,74.98c99.974,99.974,99.974,262.065,0,362.04C395.707,395.707,355.974,355.974,256,256 L437.02,74.98z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 256,
    cy: 256,
    r: 89.043
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "255.999,166.957 275.958,228.386 340.556,228.386 288.298,266.359 308.257,327.791  255.999,289.825 203.739,327.791 223.702,266.359 171.444,228.386 236.038,228.386  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,0c-0.029,0-0.057,0.002-0.086,0.002h0.171C256.057,0.002,256.029,0,256,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M256.086,0h-0.171C185.262,0.023,121.301,28.666,74.994,74.968h362.013 C390.699,28.666,326.738,0.023,256.086,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M74.995,437.033C121.321,483.352,185.315,512,256,512s134.679-28.648,181.005-74.967H74.995z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,27.826 260.145,40.58 273.555,40.58 262.706,48.463 266.851,61.217 256,53.335  245.151,61.217 249.296,48.463 238.445,40.58 251.855,40.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "193.923,27.826 198.068,40.58 211.478,40.58 200.629,48.463 204.774,61.217 193.923,53.335  183.075,61.217 187.219,48.463 176.368,40.58 189.778,40.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "318.077,27.826 322.222,40.58 335.632,40.58 324.783,48.463 328.928,61.217 318.077,53.335  307.228,61.217 311.373,48.463 300.522,40.58 313.932,40.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,450.783 260.145,463.537 273.555,463.537 262.706,471.42 266.851,484.174 256,476.291  245.151,484.174 249.296,471.42 238.445,463.537 251.855,463.537  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "193.923,450.783 198.068,463.537 211.478,463.537 200.629,471.42 204.774,484.174  193.923,476.291 183.075,484.174 187.219,471.42 176.368,463.537 189.778,463.537  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "318.077,450.783 322.222,463.537 335.632,463.537 324.783,471.42 328.928,484.174  318.077,476.291 307.228,484.174 311.373,471.42 300.522,463.537 313.932,463.537  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M78.003,251.772c6.575,10.389,3.485,24.14-6.904,30.716c-10.388,6.576-24.14,3.486-30.716-6.903 c-11.905-18.808-5.002-49.525-5.002-49.525S66.097,232.963,78.003,251.772z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 65.146,
    cy: 273.085,
    r: 11.13
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.1b136c860b44ba425c5c38039e35845a.svg";
export { ForwardRef as ReactComponent };